<div style="position: relative;">
  <div>
    @if (this.editorItemService.blocklyIsPossible()) {
    <div
      class="menu"
      [ngClass]="{'onDark': this.showCodeArea}"
      style="position: absolute; z-index: 10;"
    >
      @if (blocklyEditor) {
      <div
        (click)="blocklyEditor.saveWorkspace()"
        class="savebtn"
        [ngClass]="{
          'dirty': isDirty(),
          'onDark': this.showCodeArea

        }"
      ><i class="ri-save-3-line ri-2x"></i>
      </div>
      }
      <div
        class="codebtn cursor-pointer"
        [ngClass]="{'onDark': this.showCodeArea}"
        (click)="this.toggleCodeArea()"
      >
        <i class="ri-code-box-fill ri-2x"></i>
      </div>
    </div>
    }
  </div>
</div>
@if (this.editorItemService.blocklyIsPossible()) {
<div
  class="d-flex w-100"
  style="height: 100%;"
>
  <div
    class="left "
    [ngStyle]="{'min-width.%': showCodeArea ?  50 : 100 }"
    #left
  >
    @if (showBlocklyAfterDelay) {
    @if (this.rss.editorItem) {
    <app-blockly-editor
      #blocklyEditor
      [uniqueId]="this.rss.editorItem.uniqueId!"
      (blocklyAsCode)="onBlocklyChange($event)"
      (codeChanged)="validateJsSyntax()"
    ></app-blockly-editor>
    }
    }
  </div>
  @if (showCodeArea) {
  <div
    class="resizer d-flex text-center"
    #resizer
    (mousedown)="startResize($event)"
  >|</div>
  }
  <div
    #right
    class="flex-grow-1"
  >
    @if (this.showCodeArea && this.rss.editorItem) {
    <div class="d-flex flex-column h-100">
      <div class="d-flex justify-content-center">
        <div style="position: absolute; max-width: 50%;">
          <p-button
            severity="primary"
            variant="text"
            size="small"
            [disabled]="this.rss.editorItem.isDirty"
            (onClick)="switchToCodeEditor()"
            i18n-label="@@switch-to-code-editor"
            label="zum Code Editor wechseln"
          ></p-button>
        </div>
      </div>
      <textarea
        readonly
        #codePreview
        class="w-100 code-preview flex-grow-1"
        style="padding-top: 60px;padding-right: 80px;"
        (click)="onCursorMove(codePreview)"
        (keyup)="onCursorMove(codePreview)"
      > {{blocklyEditor?.currentCode}}
          </textarea>
      <div
        class="d-flex justify-content-end px-2 flex-shrink-0"
        style="height: 20px; font-size: 11px; color: #666; background: #f0f0f0; border-top: 1px solid #ddd; line-height: 20px;"
      >
        <span>Zeile {{cursorLine}}, Spalte {{cursorCol}}</span>
      </div>
    </div>
    }
  </div>
</div>
}
@if (this.rss.editorItem && !this.editorItemService.blocklyIsPossible()) {
<app-codemirror-dann
  [code]="this.rss.editorItem.code"
  [rows]="40"
  (finish)="this.rss.editorItem.onFinishMethod($event.code); this.rss.editorItem.code = $event.code"
></app-codemirror-dann>
}

@if (showConfirmModal) {
<div>
  <div class="modal">
    <div
      class="modal-content"
      style="max-width: 600px; margin-top: 80px;"
    >
      <div class="modal-body">
        <span i18n="@@change-code-editor-submit">Möchtest du wirklich in den Code-Editor wechseln? Inhalte im
          Blockly-Editor gehen verloren.</span>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          (click)="showConfirmModal = false"
        ><span i18n="@@cancel">Abbrechen</span></button>
        <button
          class="btn btn-primary"
          (click)="confirmSwitchToCodeEditor()"
        ><span i18n="@@confirm">Bestätigen</span></button>
      </div>
    </div>
  </div>
</div>
}